var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5176_45182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 13.4551H10C9.448 13.4551 9 13.9031 9 14.4551V23.4551C9 24.0071 9.448 24.4551 10 24.4551H14C14.552 24.4551 15 24.0071 15 23.4551V14.4551C15 13.9031 14.552 13.4551 14 13.4551Z",
    fill: "#1A1E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 17.4551H1C0.448 17.4551 0 17.9031 0 18.4551V23.4551C0 24.0071 0.448 24.4551 1 24.4551H5C5.552 24.4551 6 24.0071 6 23.4551V18.4551C6 17.9031 5.552 17.4551 5 17.4551Z",
    fill: "#1A1E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 9.45508H19C18.448 9.45508 18 9.90308 18 10.4551V23.4551C18 24.0071 18.448 24.4551 19 24.4551H23C23.552 24.4551 24 24.0071 24 23.4551V10.4551C24 9.90308 23.552 9.45508 23 9.45508Z",
    fill: "#1A1E23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.707 10.1621L19 3.86908V7.45508H21V1.45508C21 0.903078 20.552 0.455078 20 0.455078H14V2.45508H17.586L12 8.04108L8.70697 4.74808C8.31597 4.35708 7.68397 4.35708 7.29297 4.74808L2.29297 9.74808L3.70697 11.1621L7.99997 6.86908L11.293 10.1621C11.684 10.5531 12.316 10.5531 12.707 10.1621Z",
    fill: "#1A1E23"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5176_45182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.455078)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrowth);
export default __webpack_public_path__ + "static/media/icon-growth.c163ccca6c6329f1df29162c7cddd1d1.svg";
export { ForwardRef as ReactComponent };